import axios from "axios";
import {utilyUtil} from "../util/utilyUtil";
axios.defaults.baseURL = window.context.serverRoot();
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    //请求头添加token权限
    Object.assign(config,{headers:utilyUtil.getAuthorization()});
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    // console.log(response);
    let {data} = response;
    return data;
  }, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
  });